<script>
    import Icon from 'views/components/icon/Icon.svelte'
    import Lightbox from 'views/components/lightbox/Lightbox.svelte';

    export let slides = []
    export let openAtSlide = null
    export let contextElement = null

    if (contextElement) {
        contextElement.addEventListener('click', openLightbox)
    }

    function openLightbox(e) {
        e.stopImmediatePropagation()

        new Lightbox({
            target: document.body,
            props: {
                slides,
                openAtSlide,
            },
        })
    }
</script>

<button class="no-print" on:click={openLightbox}><Icon name="zoom-in"></Icon></button>

<style lang="scss">
    button {
        position: absolute;
        bottom: 8px;
        right: 8px;
        z-index: 1;

        display: flex;
        padding: 8px;
        border-radius: 12px;

        cursor: zoom-in;
        background-color: $black-25;

        transition: background-color 0.2s;

        &:hover {
            background-color: $black;
        }

        :global(svg) {
            width: 16px;
            height: 16px;
            fill: $white;
        }
    }
</style>
